<template>
  <generic-modal :title="$t('account request')" ref="generic_modal">
    <pre>{{ request }}</pre>

    <!-- PATRÓN CORRECTO: usar v-slot:footer -->
    <template v-slot:footer>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import { post, put, get, success_message, error_message } from "@/utils";
import moment from "moment";

export default {
  name: "RequestViewModal",
  components: { GenericModal },
  data() {
    return {
      request: {},
      error: "",
    };
  },
  computed: {},
  methods: {
    show(uuid) {
      let v = this;
      v.$refs.generic_modal.show_modal();
      get("/account-request/request", { uuid: uuid })
        .then((response) => {
          v.request = response;
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    set_initial_state() {
      this.request = {};
      this.error = "";
    },
  },
};
</script>

<style scoped></style>
